/**
 * True for a job detail URL path (`/en/jobs/<slug>--job_<id>`), false for
 * listing hubs (`/en/jobs`, `/en/jobs/skill/react`) and everything else.
 *
 * Zero imports on purpose: used from client components (cookie banner,
 * extension banner) and re-exported from `src/lib/sitemap/utils.ts`, which
 * pulls in an XML builder we must not ship to the browser.
 */
const JOB_DETAIL_PATH_RE = /^\/(?:en|id)\/jobs\/[^/]+--job_[^/]+\/?$/;

export function isJobDetailPath(pathname: string | null | undefined): boolean {
	return !!pathname && JOB_DETAIL_PATH_RE.test(pathname);
}
